<template>
  <img
    :src="flagUrl"
    class="countries-flag"
    width="26"
    @error="onImgError"
  >
</template>

<script>
  import { BASE_FLAG_URL, DEFAULT_FLAG } from '../mapperIsoLocale'

  export default {
    name: 'LangCircle',
    props: {
      country: {
        type: String,
        default: true
      }
    },
    computed: {
      flagUrl () {
        return `${BASE_FLAG_URL}${this.country.toLowerCase()}.svg`
      }
    },
    methods: {
      onImgError (e) {
        e.target.src = `${BASE_FLAG_URL}${DEFAULT_FLAG}.svg`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .countries-flag {
    border: 1px solid white;
    border-radius: 50%;

    &-empty {
      justify-content: center;
      color: #4F4F4F;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      margin-left: -8px;
      background: #F2F2F2;
      border-radius: 50%;
    }
  }
</style>
